import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from 'src/environments/environment';
import { Coupons } from '../_models/coupons.model';
import { PaginatedResponse } from '../_models/response.model';
import { ICouponDTO } from '../_interfaces/coupons/i-general-coupon';

@Injectable({
  providedIn: 'root',
})
export class CouponsService {
  couponsUrl = 'api/AdminCoupons';
  couponDetailsUrl = 'api/AdminCoupons/CouponDetails';
  getPromoCodesUrl = 'api/AdminCoupons/GetPromoCodes';
  filterPromoCodesUrl = 'api/AdminCoupons/FilterPromoCodes';
  promocodeUrl = 'api/AdminCoupons/CreatePromoCode';
  testsUrl = 'api/Tests';
  labsUrl = 'api/Center';
  citiesUrl = 'api/Cities';
  areasByCitiesIdsUrl = 'api/AdminAreas/GetAreasByCitiesIds';
  centerBranchesByCentersIdsAndAreasIdsUrl =
    'api/AdminCenterBranches/GetCenterBranchesByCentersIdsAndAreasIds';
  specialtyUrl = 'api/DoctorSpeciality';
  doctorsUrl = 'api/AllDoctors';

  constructor(private http: HttpClient) {}

  getPromoCodes(currentPage, pageSize, couponNameOrCode): Observable<PaginatedResponse<ICouponDTO>> {
    let params;

    if (couponNameOrCode) {
      params = new HttpParams()
        .set('couponNameOrCode', couponNameOrCode)
        .set('currentPage', currentPage)
        .set('pageSize', pageSize);
    } else {
      params = new HttpParams()
        .set('currentPage', currentPage)
        .set('pageSize', pageSize);
    }

    return this.http.get<PaginatedResponse<ICouponDTO>>(this.getPromoCodesUrl, {
      params: params,
    });
  }

  filterPromoCodes(
    isActive,
    domainIds,
    currentPage,
    pageSize
  ): Observable<PaginatedResponse<ICouponDTO>> {
    let params = new HttpParams()
      .set('isActive', isActive)
      .set('domainIds', domainIds)
      .set('currentPage', currentPage)
      .set('pageSize', pageSize);

    return this.http.get<PaginatedResponse<ICouponDTO>>(this.filterPromoCodesUrl, {
      params: params,
    });
  }

  getAllTests(): Observable<any> {
    return this.http.get(this.testsUrl);
  }

  getAllLabs(): Observable<any> {
    return this.http.get(`${this.labsUrl}/GetAllAdminCenters`);
  }

  getAllCities(): Observable<any> {
    return this.http.get(this.citiesUrl);
  }

  getAreasByCitiesIds(citiesIds): Observable<any> {
    let params = new HttpParams().set('citiesIds', citiesIds);

    return this.http.get(this.areasByCitiesIdsUrl, {
      params: params,
    });
  }

  getCenterBranchesByCentersIdsAndAreasIds(
    centersIds,
    areasIds
  ): Observable<any> {
    let params = new HttpParams()
      .set('centersIds', centersIds)
      .set('areasIds', areasIds);
    return this.http.get(this.centerBranchesByCentersIdsAndAreasIdsUrl, {
      params: params,
    });
  }

  getAllSpecialities(): Observable<any> {
    return this.http.get(`${this.specialtyUrl}/GetAllSpecialities`);
  }

  getAllDoctors(): Observable<any> {
    return this.http.get(`${this.doctorsUrl}/GetAllDoctors`);
  }

  getAllCoupons(): Observable<any> {
    return this.http.get(this.couponsUrl);
  }

  getCouponById(id: number): Observable<any> {
    return this.http.get(`${this.couponsUrl}/${id}`);
  }

  addCoupon(bodyObject) {
    return this.http.post(this.promocodeUrl, bodyObject);
  }

  addNewCoupon(payload: Coupons): Observable<any> {
    const formData = new FormData();

    formData.append('couponName', payload.couponName);
    formData.append('couponCode', payload.couponCode);
    formData.append('startDate', payload.startDate.toDateString());
    formData.append('endDate', payload.endDate.toDateString());
    formData.append(
      'discountPercentage',
      payload.discountPercentage.toString()
    );
    formData.append('amount', payload.amount.toString());
    formData.append('couponClass', payload.couponClass);
    formData.append('couponType', payload.couponType);
    formData.append('couponNameType', payload.couponNameType);

    return this.http.post(this.couponsUrl, payload);
  }

  // deleteCoupon(id: number): Observable<any> {
  //   return this.http.delete(`${this.couponsUrl}/${id}`);
  // }

  updateCoupon(payload: Coupons): Observable<any> {
    // const formData = new FormData();

    // formData.append('couponName', payload.couponName);
    // formData.append('couponCode', payload.couponCode);
    // formData.append('startDate', payload.startDate.toDateString());
    // formData.append('endDate', payload.endDate.toDateString());
    // formData.append('discountPercentage', payload.discountPercentage.toString());
    // formData.append('amount', payload.amount.toString());
    // formData.append('couponClass', payload.couponClass);
    // formData.append('couponType', payload.couponType);
    // formData.append('couponNameType', payload.couponNameType);

    return this.http.put(this.couponsUrl, payload);
  }

  getCouponDetails(CouponId): Observable<any> {
    return this.http.get(`${this.couponDetailsUrl}/${CouponId}`);
  }

  searchCouponByNameOrCode(couponNameOrCode) {
    return this.http.get(
      `${this.couponsUrl}/SearchCouponByNameOrCode/${couponNameOrCode}`
    );
  }
}
